module.exports = __webpack_public_path__ + "static/img/epic-g.a8a56d94.png";